import axios from 'axios';
import { getAxiosConfig, getDomainOrigin } from 'utils/serverConfig';

export interface IUserAccessGroup {
    group_name: string;
    store_type: string;
    plan_tags: string[];
}

export interface IUserAccessItem {
    partner_id: string;
    partner_name: string;
    lob: string;
    logo: string;
    groups: IUserAccessGroup[];
}

export interface IUserAccessUserDetails {
    name: string;
    user_id: string;
    address: string;
    phone: string;
    email: string;
    pincode: string;
}

export interface IUserAccessResponse {
    user_access: IUserAccessItem[];
    user_details: IUserAccessUserDetails | null;
}

export async function fetchUserAccess(): Promise<IUserAccessResponse> {
    const { status, data } = await axios({
        method: 'GET',
        url: `${getDomainOrigin()}/api/mpos/user/access`,
        ...getAxiosConfig(),
    });

    if (status === 200) {
        return {
            user_access: data?.user_access || [],
            user_details: data?.user_details || null,
        };
    }

    return {
        user_access: [],
        user_details: null,
    };
}
